import { render, staticRenderFns } from "./OrderSubmissionSummary.vue?vue&type=template&id=2ec9190c&scoped=true&"
import script from "./OrderSubmissionSummary.vue?vue&type=script&lang=ts&"
export * from "./OrderSubmissionSummary.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSubmissionSummary.vue?vue&type=style&index=0&id=2ec9190c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9190c",
  null
  
)

export default component.exports